import { Drawer } from 'antd';
// import { DrawerProps } from 'antd/lib/drawer';
import styled from 'styled-components';

const DefaultDrawer = styled(Drawer)`
  .ant-drawer-header {
    padding: 30px 36px;
    background-color: transparent;
  }
  .ant-drawer-close {
    top: 0;
    padding: 5px;
  }
  .ant-drawer-content-wrapper {
    max-width: 100%;
    padding: 0;
  }
  .ant-drawer-body {
    padding-left: 36px;
    padding-right: 36px;
  }
`;

export default DefaultDrawer;
